const BASE_API_URL = "https://geriactive.life/api";

export const urls = {
  //in case anything is needed to specify the original URI
  BASE_API_URL: BASE_API_URL,
  //authentication urls
  login: BASE_API_URL + "/token/",
  forgotYourPassword: BASE_API_URL + "/password_reset/",
  passwordConfirm: BASE_API_URL + "/password_reset/confirm/",
  //user urls
  userDetails: BASE_API_URL + "/user/user_details/",
  permissionLookup: BASE_API_URL + "/user/permission_lookup/",
  //Resident Side urls
  resources: BASE_API_URL + "/geriactive/resources/",
  wotd: BASE_API_URL + "/geriactive/get_wotd_word/",
  category_sorts: BASE_API_URL + "/geriactive/get_category_sorts/",
  music_player: BASE_API_URL + "/geriactive/get_music_player/",
  musicSelection: BASE_API_URL + "/geriactive/get_music_playlist/",
  finishLine: BASE_API_URL + "/geriactive/get_finish_line/",
  phraseSort: BASE_API_URL + "/geriactive/get_phrase_sort/",
  activitiesUserSettings: BASE_API_URL + "/geriactive/get_user_settings/",
  letterScramble: BASE_API_URL + "/geriactive/get_letter_scramble/",
  getIcons: BASE_API_URL + "/geriactive/get_icons/",
  phoneRecall: BASE_API_URL + "/geriactive/get_phone_recall/",
  wordHunter: BASE_API_URL + "/geriactive/get_word_hunter/",
  wordSearch: BASE_API_URL + "/geriactive/get_word_search_urls/",
  communityImage: BASE_API_URL + "/community/get_comm_image/",
  gameList: BASE_API_URL + "/geriactive/get_game_catagories_and_difficulty/",
  time: BASE_API_URL + "/analytics/get_time_tracking_per_module/",
  categorySortsGameList: BASE_API_URL + "/geriactive/get_category_sorts_game_list/"
};
